import React from "react";
import { View } from "react-native";
import FontAwesome5 from "react-native-vector-icons/FontAwesome5";
import { theme } from "@common/theme/theme";

/**
 * Pure visual component for microphone level bars
 * No business logic, just renders the mic icon and level dots
 */
const MicrophoneLevelBars = ({ micLevel = 0 }) => {
    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <FontAwesome5
                name={"microphone"}
                size={25}
                color={theme.colors.primary}
                style={{ marginRight: 10 }}
            />
            <View style={{ flexDirection: "row" }}>
                {Array.from({ length: 10 }).map((_, i) => (
                    <View
                        key={i}
                        style={{
                            width: 8,
                            height: 8,
                            borderRadius: 4,
                            marginHorizontal: 2,
                            backgroundColor:
                                i < Math.round(micLevel * 10)
                                    ? theme.colors.primary
                                    : theme.colors.light,
                        }}
                    />
                ))}
            </View>
        </View>
    );
};

export default MicrophoneLevelBars;
